import React from 'react';
import { Box, Skeleton } from '@mui/material';

const bottomButtonSkeleton = theme => ({
  marginTop: theme.spacing(4),
});

const bottomSpacingLarge = theme => ({
  marginBottom: theme.spacing(3),
});

const bottomSpacingMedium = theme => ({
  marginBottom: theme.spacing(2),
});

const container = theme => ({
  alignItems: 'center',
  backgroundColor: theme.palette.surface.white,
  display: 'flex',
  flexDirection: 'column',
  marginRight: theme.spacing(3),
  padding: theme.spacing(4, 3, 3),
  width: 216,
});

const SubscriptionBundleCardSkeleton = () => {
  return (
    <Box
      aria-label="loading tier data"
      aria-valuetext="loading tier data"
      role="progressbar"
      sx={container}
      width="216px"
    >
      <Skeleton height={21} sx={bottomSpacingMedium} variant="rectangular" width={111} />
      <Skeleton height={72} sx={bottomSpacingLarge} variant="rectangular" width="100%" />
      <Skeleton height={42} sx={bottomSpacingMedium} variant="rectangular" width={116} />

      {/* This section is a skeleton for the Expected Annual Savings Amount 
        -- Please UNCOMMENTthe line below when this piece/feature is to be included  */}
      {/* <Skeleton className={bottomSpacingLarge} height={42} variant="rect" width="100%" /> */}

      <Skeleton height={32} sx={bottomSpacingMedium} variant="rectangular" width={162} />
      <Skeleton height={32} sx={bottomSpacingMedium} variant="rectangular" width={162} />
      <Skeleton height={32} sx={bottomSpacingMedium} variant="rectangular" width={162} />
      <Skeleton height={32} sx={bottomSpacingMedium} variant="rectangular" width={162} />
      <Skeleton height={32} sx={bottomSpacingMedium} variant="rectangular" width={162} />
      <Skeleton height={32} variant="rectangular" width={162} />
      <Skeleton height={36} sx={bottomButtonSkeleton} variant="rectangular" width={104} />
    </Box>
  );
};

export default SubscriptionBundleCardSkeleton;
